/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import { FC } from 'react';
import Link from '../../ui-components/link/link';
import { Flex, Text } from 'rebass';

const Tabs = ({ scratch }) => {
    const urlProcessedOnce = window.location.pathname.substring(0, window.location.pathname.lastIndexOf("/"));
    const baseURL = urlProcessedOnce.substring(0, urlProcessedOnce.lastIndexOf("/"));

    const currentTab = window.location.pathname.substring(window.location.pathname.lastIndexOf("/"), window.location.pathname.length);
    let links = [
        {
        name: "Watch this first",
        link: `${baseURL}/watch-this-first/`
        },
        {
        name: "At a glance",
        link: `${baseURL}/at-a-glance/`
        },
        {
        name: "Project sequence",
        link: `${baseURL}/project-sequence/`
        },
        {
        name: "Extended learning",
        link: `${baseURL}/extended-learning/`
        }
    ];

    if (scratch) {
        links = [
            {
            name: "Watch this first",
            link: `${baseURL}/watch-this-first/`
            },
            {
            name: "At a glance",
            link: `${baseURL}/at-a-glance/`
            },
            {
            name: "Project sequence",
            link: `${baseURL}/project-sequence/`
            },
            {
            name: "Extended learning",
            link: `${baseURL}/extended-learning/`
            },
            {
            name: "Coder resources",
            link: `${baseURL}/coder-resources/`
            }
        ]
    }
    

    return (
        <Flex css={{position: 'absolute', bottom: '0'}} justifyContent="space-between" width="100%" maxWidth='1000px'>
        {links.map(({name, link}) => {
            if (link.includes(currentTab)) {
            return (
                <Link
                    data-gtm-link-track={`website-lesson-plan--${link.replace('/', '')}`}
                    href={link}
                    variant="tab"
                    key={link}
                    css={{
                        backgroundColor: '#fafaff',
                        padding: '20px 30px',
                        borderRadius: '10px 10px 0 0',
                        border: '0',
                        borderTop: '3px solid',
                        borderTopColor: '#a43894',
                        color: '#a43894',
                        width: scratch ? ['16%', '19%'] : ['20%', '24%']
                    }}
                >
                    <Text as="p" css={{fontWeight: '700'}}>{name}</Text>
                </Link>
            )
            } else {
            return (
                <Link
                    data-gtm-link-track={`website-lesson-plan--${link.replace('/', '')}`}
                    href={link}
                    variant="tab"
                    key={link}
                    css={{
                        backgroundColor: '#EBEBEB',
                        padding: '20px 30px',
                        borderRadius: '10px 10px 0 0',
                        border: '0',
                        borderTop: '3px solid',
                        borderTopColor: '#0E131F',
                        color: '#0E131F',
                        width: scratch ? ['16%', '19%'] : ['20%', '24%']
                    }}
                >
                    <Text as="p" css={{fontWeight: '700'}}>{name}</Text>
                </Link>
            )
            }
        })}
        </Flex>
    )
};

export default Tabs;